var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('app-aside')],1),_c('el-container',[_c('el-header',[_c('app-header')],1),_c('el-main',[_c('router-view')],1),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }